export default __webpack_public_path__ + "54f8f9317793924cdd3c39f76f8b3c37.png";